import React from 'react'
import {http} from '../../utils'
import history from '../../routes/history'
import {initDriveApp} from '../../modules/drive'
import {DriveRoot} from '../../modules/drive/app/DriveRoot'
import {FileSearch} from '../../modules/drive/pages/FileSearch'

class DriveFileSearch extends React.Component {
  state = {
    ready: false
  }

  componentDidMount() {
    initDriveApp({
      request: http,
      getToken: () => localStorage.getItem('token'),
      theme: () => localStorage.getItem('theme'),
      history
    })

    this.setState({ready: true})
  }

  render() {
    if (!this.state.ready) return null

    return <DriveRoot>
      <FileSearch/>
    </DriveRoot>
  }
}

export default DriveFileSearch